<template>
<div class="product-card">
    <!-- {{data}} -->
    <div class="img_con">
        <img v-if="data.category.image" :src="data.category.image.thumbnail" alt="">
    </div>

    <p v-if="data.product_name" class="mt-1 mb-1">{{data.product_name}}</p>
    <div class="flex product-detail">
        <p v-if="data.product_size" class="font-weight-light">{{data.product_size}} {{data.measuring_unit.name}}</p>
    </div>
</div>
</template>


<script>
export default {
    name : 'productCard',
    props : {
        data : {
            type : Object
        },
    },    
}
</script>

<style lang="scss" scoped>
.product-card{
    text-align: center;
    padding: 10px 5px;
    border-radius: 3px;
    width: 120px;
    height: 180px;
    overflow: scroll;
    // background-color: aliceblue;
    box-shadow: 1px 1px 1px rgba(28, 49, 27, 0.11);
    border: 1px solid rgba(28, 49, 27, 0.11);
    margin-right: 10px;

    img{
        width: 80%;
        margin: 0px auto;
        
    }
    p{
        font-size: 0.8rem;
    }
}
.img_con{
    min-height: 100px;
}
.product-detail{
    justify-content: space-around;

    p{
        margin: 0px;
        font-size: 0.75rem;
    }
}
</style>